/**
 *  Tutorial
 *
 *  Created by Legman on 08/06/2017.
 *
 */

import Common from "../Common";

/**
 * @class
 * @extends PIXI.Container
 */
export default class Tutorial extends PIXI.Container {
    constructor() {
        super();

        /**
         * @member {object} signals
         * @member {signals.Signal} object.signals
         */
        this.signals = {
            complete: new signals.Signal()
        };

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._panel = null;
    }

    destroy() {
        this.signals.complete.dispose();

        super.destroy();
    }

    /**
     * @param {string} [dialogue=""]
     */
    show(dialogue = "") {
        const assets = Common.assets;
        this._panel = new PIXI.Sprite(assets.getTexture("ui_tut_bg"));
        this._panel.x = Common.STAGE_WIDTH * 0.5;
        this._panel.y = p3.View.height * 0.5 + 280;
        this._panel.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._panel);

        const holder = new PIXI.Container();
        holder.y = -8;
        this._panel.addChild(holder);

        if (language === "ar") {
            this._panel.label = new PIXI.Text(dialogue, {
                fontSize: "20px", fontFamily: "Noto Kufi Arabic", fill: 0x450C41, align: "center", padding: 6,
                wordWrap: true, wordWrapWidth: 440});
            this._panel.label.x = 0;
            holder.addChild(this._panel.label);
        } else {
            this._panel.label = new PIXI.BitmapText(dialogue, font(26, "center"));
            this._panel.label.x = 0;
            this._panel.label.maxWidth = 440;
            this._panel.label.tint = 0x450C41;
            holder.addChild(this._panel.label);
        }

        holder.pivot.x = holder.width * 0.5;
        holder.pivot.y = holder.height * 0.5;

        this.animateIn(function() {
        }, this);
    }

    hide() {
        this.animateOut(function() {
            this.destroy();
        }, this);
    }

    resize() {
        // override
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        const to = this._panel.y;
        this._panel.y += 400;

        TweenMax.to(this._panel, 0.34, {
            y: to,
            ease: Back.easeOut,
            easeParams: [1],
            onComplete: callback,
            onCompleteScope: scope
        });
    }

    /**
     * @param callback
     * @param scope
     */
    animateOut(callback, scope) {
        TweenMax.to(this._panel, 0.2, {
            y: this._panel.y + 400,
            ease: Back.easeIn,
            easeParams: [1],
            onComplete: callback,
            onCompleteScope: scope
        });
    }
}